import { createContext } from 'react';

const cityContext = createContext();

export default cityContext;
